import { render, staticRenderFns } from "./ServiceDeviceCustomerRequest.vue?vue&type=template&id=678ffb83&"
import script from "./ServiceDeviceCustomerRequest.vue?vue&type=script&lang=js&"
export * from "./ServiceDeviceCustomerRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports